import { render, staticRenderFns } from "./PaymentCreate.vue?vue&type=template&id=36a3df50&scoped=true&"
import script from "./PaymentCreate.vue?vue&type=script&lang=js&"
export * from "./PaymentCreate.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCreate.vue?vue&type=style&index=0&id=36a3df50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a3df50",
  null
  
)

export default component.exports